/* ═══════════════════════════════════════════════════
   MOTION FIT STUDIO — reservaciones.js
   Calendar + Plan Selection + Booking system
   ═══════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── SCHEDULE DATA ─────────────────────────────── */
  var CLASSES = [
    { id:'yoga-manana',    name:'Yoga',          sub:'Vinyasa & Hatha',    instructor:'Ale / Isa',   days:['lun','mar','mie','jue','vie'], time:'06:00', display:'6:00 – 7:00 am',  capacity:15, cat:'adultos', color:'#b4fcb9' },
    { id:'yoga-sab',       name:'Yoga',          sub:'Vinyasa & Hatha',    instructor:'Ale / Isa',   days:['sab'],                         time:'09:00', display:'9:00 – 10:00 am', capacity:15, cat:'adultos', color:'#b4fcb9' },
    { id:'yoga-dom',       name:'Yoga',          sub:'Vinyasa & Hatha',    instructor:'Ale / Isa',   days:['dom'],                         time:'09:00', display:'9:00 – 10:00 am', capacity:15, cat:'adultos', color:'#b4fcb9' },
    { id:'pilates-lm',     name:'Pilates Mat',   sub:'Core & Postura',     instructor:'Susy / Gaby', days:['lun','mie'],                   time:'10:00', display:'10:00 – 11:00 am',capacity:15, cat:'adultos', color:'#a78bfa' },
    { id:'pilates-mar',    name:'Pilates Mat',   sub:'Core & Postura',     instructor:'Susy / Gaby', days:['mar'],                         time:'09:00', display:'9:00 – 10:00 am', capacity:15, cat:'adultos', color:'#a78bfa' },
    { id:'pilates-jue',    name:'Pilates Mat',   sub:'Core & Postura',     instructor:'Susy / Gaby', days:['jue'],                         time:'08:00', display:'8:00 – 9:00 am',  capacity:15, cat:'adultos', color:'#a78bfa' },
    { id:'build-tone',     name:'Build & Tone',  sub:'Fuerza Funcional',   instructor:'Elva',        days:['lun','mie','vie'],             time:'09:00', display:'9:00 – 10:00 am', capacity:15, cat:'adultos', color:'#f97316' },
    { id:'funcional',      name:'Funcional',     sub:'Alta Intensidad',    instructor:'Adal',        days:['mar','jue'],                   time:'18:00', display:'6:00 – 7:00 pm',  capacity:15, cat:'adultos', color:'#ef4444' },
    { id:'hiphop-kids',    name:'Hip Hop Kids',  sub:'Kids',               instructor:'Brandon',     days:['sab'],                         time:'10:00', display:'10:00 – 11:00 am',capacity:12, cat:'ninos',   color:'#facc15' },
    { id:'hiphop-teens',   name:'Hip Hop Teens', sub:'Teens',              instructor:'Brandon',     days:['lun','mie'],                   time:'19:00', display:'7:00 – 8:00 pm',  capacity:12, cat:'ninos',   color:'#facc15' },
    { id:'jazz',           name:'Jazz',          sub:'Ninos',              instructor:'Michel',      days:['lun','mie'],                   time:'17:00', display:'5:00 – 6:00 pm',  capacity:12, cat:'ninos',   color:'#fb7185' },
    { id:'baby-ballet',    name:'Baby Ballet',   sub:'Ninos',              instructor:'Michel',      days:['lun','mar','mie','jue'],       time:'16:00', display:'4:00 – 5:00 pm',  capacity:12, cat:'ninos',   color:'#f0abfc' },
    { id:'capoeira',       name:'Capoeira',      sub:'Ninos',              instructor:'Adal',        days:['mar','jue'],                   time:'17:00', display:'5:00 – 6:00 pm',  capacity:12, cat:'ninos',   color:'#34d399' }
  ];

  var ADULT_1_CLASE = {
    'Yoga':         'yoga-1-clase',
    'Pilates Mat':  'pilates-mat-1-clase',
    'Build & Tone': 'build-tone-1-clase',
    'Funcional':    'funcional-1-clase'
  };
  var ADULT_5_CLASES_HANDLE = 'adultos-paquete-5-clases';

  /* ── CLASS SLUG MAP (deep links from home tiles) ── */
  var CLASS_SLUG_MAP = {
    'yoga':        function(c) { return c.name === 'Yoga'; },
    'pilates':     function(c) { return c.name === 'Pilates Mat'; },
    'hiphop':      function(c) { return c.name.indexOf('Hip Hop') !== -1; },
    'baby-ballet': function(c) { return c.name === 'Baby Ballet'; },
    'build-tone':  function(c) { return c.name === 'Build & Tone'; }
  };

  var DAYS_ES = ['dom','lun','mar','mie','jue','vie','sab'];
  var DAYS_LABEL = { dom:'Domingo', lun:'Lunes', mar:'Martes', mie:'Miercoles', jue:'Jueves', vie:'Viernes', sab:'Sabado' };
  var STORAGE_KEY = 'motion_reservations';

  /* ── STATE ─────────────────────────────────────── */
  var state = {
    weekOffset: 0,
    filter: 'all',
    bookingSlot: null,
    multiSelectMode: false,
    multiSelectedSlots: []
  };

  /* ── DATE HELPERS ──────────────────────────────── */
  function getWeekDates(offset) {
    var now = new Date();
    var day = now.getDay();
    var monday = new Date(now);
    monday.setDate(now.getDate() - (day === 0 ? 6 : day - 1) + offset * 7);
    monday.setHours(0,0,0,0);
    var week = [];
    for (var i = 0; i < 7; i++) {
      var d = new Date(monday);
      d.setDate(monday.getDate() + i);
      week.push(d);
    }
    return week;
  }

  function dateKey(date) { return date.toISOString().slice(0, 10); }
  function slotKey(classId, dateStr) { return 'slot__' + classId + '__' + dateStr; }
  function formatDateShort(date) { return date.getDate() + '/' + (date.getMonth() + 1); }

  function isToday(date) {
    var t = new Date();
    return date.getDate() === t.getDate() &&
           date.getMonth() === t.getMonth() &&
           date.getFullYear() === t.getFullYear();
  }

  function isPast(date, time) {
    var now = new Date();
    var parts = time.split(':');
    var slotTime = new Date(date);
    slotTime.setHours(parseInt(parts[0]), parseInt(parts[1]), 0, 0);
    return slotTime < now;
  }

  function isMobile() { return window.innerWidth <= 768; }

  /* ── STORAGE ────────────────────────────────────── */
  function loadReservations() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); }
    catch(e) { return {}; }
  }
  function saveReservations(data) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch(e) {}
  }
  function getSlotReservations(classId, dateStr) {
    return loadReservations()[slotKey(classId, dateStr)] || [];
  }
  function getAvailable(classObj, dateStr) {
    return Math.max(0, classObj.capacity - getSlotReservations(classObj.id, dateStr).length);
  }
  function addReservation(classId, dateStr) {
    var all = loadReservations();
    var key = slotKey(classId, dateStr);
    if (!all[key]) all[key] = [];
    all[key].push({ ts: new Date().toISOString() });
    saveReservations(all);
  }

  /* ── CALENDAR RENDER ────────────────────────────── */
  function renderCalendar() {
    var grid = document.getElementById('calendarGrid');
    if (!grid) return;
    var week = getWeekDates(state.weekOffset);
    updateWeekLabel(week);
    var html = '';
    week.forEach(function (date) {
      var dayCode = DAYS_ES[date.getDay()];
      var dateStr = dateKey(date);
      var today = isToday(date);
      var dayClasses = CLASSES.filter(function (c) {
        return c.days.indexOf(dayCode) !== -1 &&
               (state.filter === 'all' || c.cat === state.filter);
      });
      dayClasses.sort(function (a, b) { return a.time.localeCompare(b.time); });
      html += '<div class="cal-col' + (today ? ' cal-today' : '') + '" data-date="' + dateStr + '">';
      html += '<div class="cal-day-head">';
      html += '<span class="cal-day-name">' + DAYS_LABEL[dayCode] + '</span>';
      html += '<span class="cal-day-date' + (today ? ' today-badge' : '') + '">' + formatDateShort(date) + (today ? ' — Hoy' : '') + '</span>';
      html += '</div>';
      if (dayClasses.length === 0) {
        html += '<div class="cal-empty">Sin clases</div>';
      } else {
        dayClasses.forEach(function (c) {
          var avail = getAvailable(c, dateStr);
          var booked = c.capacity - avail;
          var past = isPast(date, c.time);
          var pct = Math.round((booked / c.capacity) * 100);
          var multiBlocked = state.multiSelectMode && c.cat === 'ninos';
          var isSelected = state.multiSelectMode && state.multiSelectedSlots.some(function(s) {
            return s.classId === c.id && s.dateStr === dateStr;
          });
          var statusClass;
          if (multiBlocked) { statusClass = 'slot-multiblock'; }
          else if (isSelected) { statusClass = 'slot-selected'; }
          else if (past) { statusClass = 'slot-past'; }
          else if (avail === 0) { statusClass = 'slot-full'; }
          else if (avail <= 3) { statusClass = 'slot-low'; }
          else { statusClass = 'slot-open'; }
          var statusText = past ? 'Terminada' : avail === 0 ? 'Llena' : avail + ' lugares';
          var clickable = !past && avail > 0 && !multiBlocked && !isSelected;
          html += '<div class="cal-slot ' + statusClass + '" ';
          html += 'data-class-id="' + c.id + '" data-date="' + dateStr + '" ';
          if (clickable) html += 'onclick="openBooking(\'' + c.id + '\',\'' + dateStr + '\')" ';
          html += 'style="--slot-color:' + c.color + '">';
          html += '<div class="slot-color-bar"></div>';
          html += '<div class="slot-body">';
          html += '<div class="slot-name">' + c.name + '</div>';
          html += '<div class="slot-sub">' + c.sub + '</div>';
          html += '<div class="slot-time">' + c.display + '</div>';
          html += '<div class="slot-instructor">' + c.instructor + '</div>';
          html += '</div>';
          html += '<div class="slot-footer">';
          html += '<div class="slot-bar-wrap"><div class="slot-bar" style="width:' + pct + '%"></div></div>';
          if (!isSelected) {
            html += '<div class="slot-status ' + statusClass + '-text">' + statusText + '</div>';
          }
          if (isSelected) {
            html += '<div class="slot-selected-badge">&#10003; Seleccionada</div>';
          } else if (clickable) {
            var ctaText = state.multiSelectMode ? 'Agregar +' : 'Reservar +';
            html += '<div class="slot-cta">' + ctaText + '</div>';
          }
          html += '</div>';
          html += '</div>';
        });
      }
      html += '</div>';
    });
    grid.innerHTML = html;
  }

  function updateWeekLabel(week) {
    var lbl = document.getElementById('weekLabel');
    if (!lbl) return;
    lbl.textContent = formatDateShort(week[0]) + ' – ' + formatDateShort(week[6]);
    document.getElementById('prevWeek').disabled = state.weekOffset <= 0;
  }

  /* ── MOBILE: SCROLL TO TODAY ────────────────────── */
  function scrollToToday() {
    if (!isMobile()) return;
    var grid = document.getElementById('calendarGrid');
    if (!grid) return;
    setTimeout(function() {
      var todayCol = grid.querySelector('.cal-today');
      if (todayCol) {
        grid.scrollTo({ left: todayCol.offsetLeft - 20, behavior: 'smooth' });
      } else {
        grid.scrollTo({ left: 0, behavior: 'auto' });
      }
    }, 80);
  }

  /* ── FILTER / WEEK ──────────────────────────────── */
  window.resFilter = function (f, btn) {
    state.filter = f;
    document.querySelectorAll('.res-filter').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
    renderCalendar();
    scrollToToday();
  };

  window.changeWeek = function (dir) {
    if (state.weekOffset + dir < 0) return;
    state.weekOffset += dir;
    renderCalendar();
    if (isMobile()) {
      var grid = document.getElementById('calendarGrid');
      if (grid) grid.scrollTo({ left: 0, behavior: 'auto' });
      if (state.weekOffset === 0) scrollToToday();
    }
  };

  /* ── BOOKING MODAL ──────────────────────────────── */
  window.openBooking = function (classId, dateStr) {
    var classObj = CLASSES.find(function (c) { return c.id === classId; });
    if (!classObj) return;
    if (state.multiSelectMode) { addToMultiSelect(classId, dateStr, classObj); return; }
    var avail = getAvailable(classObj, dateStr);
    state.bookingSlot = { classId: classId, dateStr: dateStr, classObj: classObj };
    document.getElementById('bookingTitle').innerHTML =
      classObj.name.toUpperCase() + '<br><span style="color:var(--mint)">' + classObj.sub + '</span>';
    document.getElementById('bookingSubtitle').textContent =
      classObj.display + ' · ' + DAYS_LABEL[DAYS_ES[new Date(dateStr + 'T12:00:00').getDay()]] +
      ' ' + dateStr.slice(8) + '/' + dateStr.slice(5,7);
    updateSpotsBar(avail, classObj.capacity);
    if (avail === 0) {
      document.getElementById('planStep').style.display = 'none';
      document.getElementById('bookingFull').style.display = '';
    } else {
      document.getElementById('planStep').style.display = '';
      document.getElementById('bookingFull').style.display = 'none';
      if (classObj.cat === 'adultos') {
        document.getElementById('planAdultos').style.display = '';
        document.getElementById('planNinos').style.display = 'none';
      } else {
        document.getElementById('planAdultos').style.display = 'none';
        document.getElementById('planNinos').style.display = '';
      }
    }
    document.getElementById('bookingModal').classList.add('open');
    document.body.style.overflow = 'hidden';
  };

  function updateSpotsBar(avail, capacity) {
    var pct = Math.round(((capacity - avail) / capacity) * 100);
    var fill = document.getElementById('bookingBarFill');
    var num = document.getElementById('bookingSpotsNum');
    if (!fill || !num) return;
    fill.style.width = pct + '%';
    fill.style.background = avail === 0 ? '#ef4444' : avail <= 3 ? '#f97316' : 'var(--mint)';
    num.textContent = avail + ' / ' + capacity;
    num.style.color = avail === 0 ? '#ef4444' : avail <= 3 ? '#f97316' : 'var(--mint)';
  }

  window.closeBooking = function () {
    document.getElementById('bookingModal').classList.remove('open');
    document.body.style.overflow = '';
    state.bookingSlot = null;
  };

  /* ── PLAN SELECTION ─────────────────────────────── */
  window.selectPlan = function (plan) {
    var slot = state.bookingSlot;
    if (!slot) return;
    closeBooking();
    if (plan === '1clase') {
      openWaiver(slot.classObj.name + ' &ndash; 1 Clase &middot; $350 MXN', '/products/' + (ADULT_1_CLASE[slot.classObj.name] || 'yoga-1-clase'));
    } else if (plan === '5clases') {
      state.multiSelectMode = true;
      state.multiSelectedSlots = [{ classId: slot.classId, dateStr: slot.dateStr, classObj: slot.classObj }];
      updateMultiSelectBanner();
      renderCalendar();
    } else if (plan === 'inscripcion') {
      openWaiver(slot.classObj.name + ' &ndash; Inscripci&oacute;n &middot; $1,500 MXN', '/products/kids-inscripcion');
    } else if (plan === 'mensualidad') {
      openWaiver(slot.classObj.name + ' &ndash; Mensualidad &middot; $1,000 MXN', '/products/kids-mensualidad');
    }
  };

  /* ── MULTI-SELECT ───────────────────────────────── */
  function addToMultiSelect(classId, dateStr, classObj) {
    if (classObj.cat !== 'adultos') return;
    var exists = state.multiSelectedSlots.some(function(s) { return s.classId === classId && s.dateStr === dateStr; });
    if (exists) return;
    state.multiSelectedSlots.push({ classId: classId, dateStr: dateStr, classObj: classObj });
    updateMultiSelectBanner();
    renderCalendar();
    if (state.multiSelectedSlots.length >= 5) finishMultiSelect();
  }
  function updateMultiSelectBanner() {
    var banner = document.getElementById('multiSelectBanner');
    var count = document.getElementById('multiSelectCount');
    if (!banner || !count) return;
    banner.style.display = '';
    count.textContent = state.multiSelectedSlots.length + ' / 5 seleccionadas';
  }
  function finishMultiSelect() {
    state.multiSelectedSlots.forEach(function(s) { addReservation(s.classId, s.dateStr); });
    cancelMultiSelect();
    openWaiver('5 Clases Adultos &middot; $1,350 MXN', '/products/' + ADULT_5_CLASES_HANDLE);
  }
  window.cancelMultiSelect = function () {
    state.multiSelectMode = false;
    state.multiSelectedSlots = [];
    var banner = document.getElementById('multiSelectBanner');
    if (banner) banner.style.display = 'none';
    renderCalendar();
  };

  /* ── ADMIN PANEL ────────────────────────────────── */
  var adminFilter_state = 'all';
  window.adminFilter = function (f, btn) {
    adminFilter_state = f;
    document.querySelectorAll('.res-filter').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
    renderAdminTable();
  };
  function renderAdminTable() {
    var statsEl = document.getElementById('adminStats');
    var tableEl = document.getElementById('adminTable');
    if (!statsEl || !tableEl) return;
    var all = loadReservations();
    var today = dateKey(new Date());
    var week = getWeekDates(0).map(dateKey);
    var rows = [];
    Object.keys(all).forEach(function (key) {
      var parts = key.split('__');
      if (parts.length < 3) return;
      var classObj = CLASSES.find(function (c) { return c.id === parts[1]; });
      if (!classObj) return;
      all[key].forEach(function (r) { rows.push({ classObj: classObj, dateStr: parts[2], ts: r.ts }); });
    });
    rows = rows.filter(function (r) {
      if (adminFilter_state === 'hoy') return r.dateStr === today;
      if (adminFilter_state === 'semana') return week.indexOf(r.dateStr) !== -1;
      return true;
    });
    rows.sort(function (a, b) {
      if (a.dateStr !== b.dateStr) return b.dateStr.localeCompare(a.dateStr);
      return a.classObj.time.localeCompare(b.classObj.time);
    });
    statsEl.innerHTML =
      '<div class="admin-stat"><span class="admin-stat-n">' + rows.length + '</span><span class="admin-stat-l">Reservaciones' + (adminFilter_state !== 'all' ? ' (' + adminFilter_state + ')' : '') + '</span></div>' +
      '<div class="admin-stat"><span class="admin-stat-n">' + Object.keys(all).length + '</span><span class="admin-stat-l">Clases con reservas</span></div>';
    if (rows.length === 0) { tableEl.innerHTML = '<div class="admin-empty">No hay reservaciones para este filtro.</div>'; return; }
    var html = '<table class="admin-table"><thead><tr><th>Fecha</th><th>Clase</th><th>Horario</th><th>Registrado</th><th></th></tr></thead><tbody>';
    rows.forEach(function (r) {
      html += '<tr><td>' + r.dateStr + '</td>';
      html += '<td><span class="admin-dot" style="background:' + r.classObj.color + '"></span>' + r.classObj.name + '</td>';
      html += '<td>' + r.classObj.display + '</td>';
      html += '<td style="color:var(--gray);font-size:.7rem">' + r.ts.slice(0,16).replace('T',' ') + '</td>';
      html += '<td><button class="admin-del" onclick="adminDelete(\'' + r.classObj.id + '\',\'' + r.dateStr + '\',\'' + r.ts + '\')">X</button></td></tr>';
    });
    html += '</tbody></table>';
    tableEl.innerHTML = html;
  }
  window.adminDelete = function (classId, dateStr, ts) {
    if (!confirm('Eliminar esta reservacion?')) return;
    var all = loadReservations();
    var key = slotKey(classId, dateStr);
    if (all[key]) {
      all[key] = all[key].filter(function (r) { return r.ts !== ts; });
      if (all[key].length === 0) delete all[key];
      saveReservations(all);
    }
    renderAdminTable(); renderCalendar();
  };
  window.adminExport = function () {
    var all = loadReservations();
    var rows = [['Fecha','Clase','Horario','Registrado']];
    Object.keys(all).forEach(function (key) {
      var parts = key.split('__');
      if (parts.length < 3) return;
      var classObj = CLASSES.find(function (c) { return c.id === parts[1]; });
      if (!classObj) return;
      all[key].forEach(function (r) { rows.push([parts[2], classObj.name, classObj.display, r.ts.slice(0,16)]); });
    });
    var csv = rows.map(function (r) { return r.map(function (c) { return '"' + c + '"'; }).join(','); }).join('\n');
    var a = document.createElement('a');
    a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
    a.download = 'motion-reservaciones-' + dateKey(new Date()) + '.csv';
    a.click();
  };
  window.adminClearOld = function () {
    if (!confirm('Eliminar reservaciones de semanas anteriores?')) return;
    var all = loadReservations();
    var minDate = getWeekDates(0).map(dateKey)[0];
    Object.keys(all).forEach(function (key) {
      var parts = key.split('__');
      if (parts[2] && parts[2] < minDate) delete all[key];
    });
    saveReservations(all); renderAdminTable();
    alert('Listo. Reservaciones antiguas eliminadas.');
  };

  /* ── DEEP LINK INIT ─────────────────────────────── */
  function deepLinkInit() {
    var params = new URLSearchParams(window.location.search);
    var clase = params.get('clase');
    if (!clase || !CLASS_SLUG_MAP[clase]) return;
    var matcher = CLASS_SLUG_MAP[clase];
    var matchingClasses = CLASSES.filter(matcher);
    if (matchingClasses.length === 0) return;
    var style = document.createElement('style');
    style.textContent = '@keyframes motionPulse{0%,100%{box-shadow:0 0 0 0 rgba(180,252,185,.7)}50%{box-shadow:0 0 0 14px rgba(180,252,185,0)}}.slot-highlight-pulse{animation:motionPulse .9s ease-in-out 3;outline:2px solid #b4fcb9;}';
    document.head.appendChild(style);
    var now = new Date();
    var bestDate = null;
    var bestWeekOffset = 0;
    for (var daysAhead = 0; daysAhead <= 13; daysAhead++) {
      var candidate = new Date(now);
      candidate.setDate(now.getDate() + daysAhead);
      candidate.setHours(0, 0, 0, 0);
      var dayCode = DAYS_ES[candidate.getDay()];
      var found = matchingClasses.find(function(c) {
        return c.days.indexOf(dayCode) !== -1 && !isPast(candidate, c.time);
      });
      if (found) {
        bestDate = candidate;
        var todayMonday = new Date(now);
        var todayDay = now.getDay();
        todayMonday.setDate(now.getDate() - (todayDay === 0 ? 6 : todayDay - 1));
        todayMonday.setHours(0, 0, 0, 0);
        var diffDays = Math.round((bestDate - todayMonday) / (24 * 60 * 60 * 1000));
        bestWeekOffset = Math.floor(diffDays / 7);
        break;
      }
    }
    if (!bestDate) return;
    state.weekOffset = bestWeekOffset;
    renderCalendar();
    setTimeout(function() {
      var dateStr = dateKey(bestDate);
      var targetSlot = null;
      document.querySelectorAll('.cal-slot[data-date="' + dateStr + '"]').forEach(function(el) {
        if (targetSlot) return;
        var cid = el.getAttribute('data-class-id');
        if (matchingClasses.some(function(c) { return c.id === cid; })) targetSlot = el;
      });
      if (targetSlot) {
        targetSlot.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' });
        targetSlot.classList.add('slot-highlight-pulse');
        setTimeout(function() { targetSlot.classList.remove('slot-highlight-pulse'); }, 2700);
      }
    }, 150);
  }

  /* ── INIT ───────────────────────────────────────── */
  function motionInit() {
    if (document.getElementById('calendarGrid')) {
      renderCalendar();
      scrollToToday();
      deepLinkInit();
    }
    if (document.getElementById('adminTable')) { renderAdminTable(); }
    var bm = document.getElementById('bookingModal');
    if (bm) { bm.addEventListener('click', function (e) { if (e.target === bm) closeBooking(); }); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', motionInit);
  } else {
    motionInit();
  }

})();
